module.exports = __webpack_public_path__ + "img/GT120-HP-T6.c6d58a1e.jpg";